import React from 'react';
import { withResponsiveFlags, useResponsiveTextProps } from "~/hoc/withResponsiveProps";
import {  HStack } from "native-base"
import { H1, H3 } from "../Typography";
import { Icon } from "../Icon";

const verticalAlignStyle = {verticalAlign: 'middle'};
const ResponsiveTitle = withResponsiveFlags(({ title, icon, iconFamily, isSmallScreen, ...rest }) => {
    const textProps = useResponsiveTextProps(isSmallScreen, isSmallScreen ? 150 : 0, 218);

    const TitleComponent = isSmallScreen ? H3 : H1;

    const titleBody = (
        <TitleComponent { ...rest } style={React.useMemo(() => ([rest.style, verticalAlignStyle]), [rest.style])}>
            {title}
        </TitleComponent>
    )

    if (!icon) return titleBody;

    return (
        <HStack {...textProps} alignItems="center" space="2">
            <Icon color="muted.700" size={isSmallScreen ? "4" : "6"} type={icon} iconFamily={iconFamily}></Icon>
            {titleBody}
        </HStack>
    )
}, { includeKeys: ['isSmallScreen'] });

export default ResponsiveTitle;